import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import {
    GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE,
    GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS,
    GET_INSIDE_SHIP_TO_ADDRESS_FAILURE,
    GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS,
} from '../action/types';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getShipToAddress(action) {
    const {isInside, searchValue} = action.payload;

    const surgeryAccountId = yield select((state) =>
        isInside
            ? state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
                  ?.accountId
            : state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
                  ?.accountId
    );

    const selectedAccountDetails = yield select((state) =>
        isInside
            ? state.reportShipToAddressReducer.insideSurgeryDetails?.accountId
            : state.reportShipToAddressReducer.outsideSurgeryDetails?.accountId
    );

    const isCondensedView = yield select((state) =>
        state.loginReducer.isCondensedView
    );
    const { billToShipToPartnerRole } = yield select((state) =>
           state.loginReducer
       );
     //const billToShipToPartnerRole = localStorage.getItem('billToShipToPartnerRole');
     const sapPartnerId1 = surgeryAccountId || selectedAccountDetails;
     const sapPartnerIdJapanUser = yield select(
        (state) => isInside ? state.reportShipToAddressReducer.insideSurgeryDetails.billToId?.billToNumber :
                state.reportShipToAddressReducer.outsideSurgeryDetails?.billToId?.billToNumber);
    const sapPartnerIdResult = function (){
        if(billToShipToPartnerRole == 'BILL_TO'){
            return sapPartnerIdJapanUser;
        }
        else 
        return sapPartnerId1;
    };
   const sapPartnerId = sapPartnerIdResult();

    try {
        const result = yield axios
        .get(
            `occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/order/surgery/shiptoaddress?sapPartnerId=${encodeURIComponent(sapPartnerId)}&searchTerm=${encodeURIComponent(searchValue)}`
        )
        .then((response) => response.data);
        const updatedResult =  { ...result,
            shipToData: {
                ...result.shipToData,
                nonTissueAddress: result.shipToData?.nonTissueAddress?.map((item) => {
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                }),
                tissueAddress: result.shipToData?.tissueAddress?.map((item)=>{
                    const shippingAddress = `${item.accountName} ${accountNumberZeroTrimmer(item.shippingAddressId)}`;
                    item.formattedShippingAddressId = shippingAddress;
                    return item;
                })
            },
        }; 
        if (sapPartnerId && action.payload.isInside) {
            yield put({
                type: GET_INSIDE_SHIP_TO_ADDRESS_SUCCESS,
                payload: updatedResult.shipToData || [],
                isCondensedView:isCondensedView,
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
            });
        } else {
            yield put({
                type: GET_OUTSIDE_SHIP_TO_ADDRESS_SUCCESS,
                payload: updatedResult.shipToData || [],
                isCondensedView:isCondensedView,
                statusCode: updatedResult.statusCode,
                statusMessage: updatedResult.statusMessage,
            });
        }
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/order/surgery/shiptoaddress?sapPartnerId=${encodeURIComponent(sapPartnerId)}&searchTerm=${encodeURIComponent(searchValue)}`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        if (sapPartnerId && action.payload.isInside) {
            yield put({
                type: GET_INSIDE_SHIP_TO_ADDRESS_FAILURE,
                statusCode: errorHandler('503'),
                statusMessage: e.Error,
            });
        } else {
            yield put({
                type: GET_OUTSIDE_SHIP_TO_ADDRESS_FAILURE,
                statusCode: errorHandler('503'),
                statusMessage: e.Error,
            });
        }
    }
}
